import MdaeAutoComplete from "./component";
import { IAutocompleteOptions } from "devextreme-react/autocomplete";
export interface IMdaeAutoCompleteProps extends IAutocompleteOptions {
  id: string;
  mdaeAutocompleteTitle?: string;
  required?: boolean;
  onCustomItemCreating?: (e: any) => void;
  MdaeAutocompleteTitleComponent?:React.FC<any>;
  MdaeAutocompleteTitleComponentClassName?:string;
}
export default MdaeAutoComplete;
